import { useI18n } from "@wato/i18n/react";
import { IconButton } from "../../../components/IconButton";
import { AutomationStatusChip } from "../../automation-pause/MasterSwitch";
import { NotificationBell } from "../../notifications/NotificationBell";
import { AvatarMenu } from "../HeaderMenus";

/** OWN-320: bell, automation status, account menu and the collapse toggle at the bottom of the desktop sidebar. */
export function SidebarFooter({
  workspaceId,
  collapsed,
  onToggle,
}: {
  workspaceId: string;
  collapsed: boolean;
  onToggle: () => void;
}) {
  const { t } = useI18n();
  const toggleLabel = collapsed ? t("dashboard.nav.showSidebar") : t("dashboard.nav.hideSidebar");
  return (
    <div
      data-testid="sidebar-footer"
      className={`flex items-center gap-1 rounded-2xl bg-surface p-2 shadow-sm ${collapsed ? "flex-col" : "flex-wrap justify-between"}`}
    >
      <NotificationBell workspaceId={workspaceId} placement="start-up" />
      <AutomationStatusChip compact placement="start-up" />
      <AvatarMenu workspaceId={workspaceId} placement="start-up" showName={false} />
      <IconButton
        data-testid="sidebar-toggle"
        variant="ghost"
        label={toggleLabel}
        icon="☰"
        aria-pressed={!collapsed}
        onClick={onToggle}
      />
    </div>
  );
}
